module.exports = __webpack_public_path__ + "static/img/bg_SeaBuilding_2.46175a69.png";